import { TransactionStatus } from '../../../enums';

export const statusOptions = [
  { label: 'All', value: 'All' },
  ...Object.values(TransactionStatus)
    .filter((status) => status !== 'CANCELLED')
    .map((status) => ({
      label: status,
      value: status
    }))
];

export const particularOptions = [
  { label: 'Tuition Fee', value: 'Tuition Fee' },
  { label: 'Term Fee', value: 'Term Fee' },
  { label: 'Miscellaneous Fee', value: 'Miscellaneous Fee' },
  { label: 'Admission Fee', value: 'Admission Fee' },
  { label: 'Security Deposit', value: 'Security Deposit' },
  { label: 'Registration Fee', value: 'Registration Fee' },
  { label: 'Activity Fee', value: 'Activity Fee' },
  { label: 'Imprest', value: 'Imprest' },
  { label: 'Indian Board', value: 'Indian Board' },
  { label: 'International Board', value: 'International Board' },
  { label: 'Laboratory Fee', value: 'Laboratory Fee' },
  { label: 'Part A', value: 'Part A' },
  { label: 'Part B', value: 'Part B' }
];
